
import UserIndex from '../../views/Admin/User/UserIndex';
import UserEdit from '../../views/Admin/User/UserEdit';
import UserCreate from '../../views/Admin/User/UserCreate';
import LayoutPrimary from '../../layouts/Primary';

export default [
    {
        path: '/user/create',
        name: 'UserCreate',
        component: UserCreate,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/user/index',
        name: 'UserIndex',
        component: UserIndex,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/user/edit/:id',
        name: 'UserEdit',
        component: UserEdit,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
];
